import React from 'react';
import '../../styles/global.css';

const IOSAppSupport: React.FC = () => {
  return (
    <div className="support-page container">
      <h1>Caelestis Fertility – Support</h1>
      <p>Welcome to Caelestis Support! We’re here to help you get the most out of your AI fertility assistant.</p>

      <h2>🔹 Frequently Asked Questions</h2>
      <dl className="faq-list">
        <dt>What is Caelestis?</dt>
        <dd>Caelestis is an AI fertility assistant developed by AIplify Services. It provides instant, personalized answers about IVF, egg freezing, and fertility care—based on data from real fertility clinics.</dd>

        <dt>Is Caelestis a medical provider?</dt>
        <dd>No. Caelestis does not provide medical advice or treatment. It delivers guidance based on clinical data to help you understand your options and prepare for conversations with a medical professional.</dd>

        <dt>Where does the information come from?</dt>
        <dd>Caelestis is trained using verified information from fertility clinics and other trusted medical sources. This ensures you receive accurate, relevant insights.</dd>

        <dt>Is my data private?</dt>
        <dd>Yes. We take privacy seriously. No personal health information is stored unless you give explicit consent. All interactions are encrypted and handled securely.</dd>

        <dt>How do I get in touch with support?</dt>
        <dd>You can contact our team at <a href="mailto:contact@aiplify.com">contact@aiplify.com</a>. We typically respond within 1–2 business days.</dd>
      </dl>

      <h2>📬 Need Help?</h2>
      <p>For technical issues, questions, or feedback about the Caelestis app, don’t hesitate to reach out:</p>
      <ul>
        <li>AIplify Services</li>
        <li>📧 <a href="mailto:contact@aiplify.com">contact@aiplify.com</a></li>
        <li>🌐 www.aiplify.com</li>
      </ul>
    </div>
  );
};

export default IOSAppSupport;
